import React from 'react';
import Panel from 'rsuite/Panel';
import PropTypes from 'prop-types';

export default function SectionPanel(props) {
  const {title, children} = props;
  return(
    <Panel>
      <div>
        {title}
      </div>
      <div>
        {children}
      </div>
    </Panel>
  )
}


SectionPanel.propTypes = {
  title: PropTypes.node
}